import { Component, Input, ViewChild } from '@angular/core'

import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts'
import { ChartOptions } from 'src/app/shared/types/chart-options'
import { StatCounter } from 'src/app/shared/interfaces/statistics/stat-counter.interface'
import { CardComponent } from '../../card/card.component'
import { Utils } from 'src/app/shared/utilties'

const sparkLineData = [...Array(12).keys()].map((x) => 0)

interface YearData {
    name: string
    color: string
    data: number[]
}

@Component({
    selector: 'sf-sparkline-area-chart',
    imports: [NgApexchartsModule, CardComponent],
    templateUrl: './sparkline-area-chart.component.html',
    styleUrls: ['./sparkline-area-chart.component.scss']
})
export class SparklineAreaChartComponent {
    private _chartData: StatCounter[] | null = null
    @Input()
    set chartData(value: StatCounter[] | null) {
        this._chartData = value
        this.updateChartData()
    }
    get chartData(): StatCounter[] | null {
        return this._chartData
    }

    private _chartTitle: string = ''
    @Input()
    set chartTitle(value: string) {
        this._chartTitle = value
    }
    get chartTitle(): string {
        return this._chartTitle
    }

    @ViewChild('chartspark1', { static: true })
    chart!: ChartComponent

    public chartOptions: Partial<ChartOptions> = {
        chart: {
            type: 'area',
            height: 300,
            toolbar: {
                show: false,
            },
            sparkline: {
                enabled: false,
            },
        },
        series: [
            {
                name: 'This Year',
                data: sparkLineData,
            },
            {
                name: 'Last Year',
                data: sparkLineData,
            },
        ],
        colors: ['#ffdd00', '#cccccc'],
        xaxis: {
            categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            title: {
                text: 'Month',
            },
        },
        subtitle: {
            text: '',
            offsetX: 0,
            style: {
                fontSize: '14px',
            },
        },
        stroke: {
            curve: 'straight',
        },
        fill: {
            opacity: 0.3,
        },
        yaxis: {
            min: 0,
        },
    }

    updateChartData(): void {
        const chartData = this._chartData as StatCounter[]

        if (!chartData) return

        const manipulatedChartData = chartData.reduce(
            (accumulator: { [year: string]: YearData }, currentValue: StatCounter) => {
                const year = currentValue.year.toString()
                if (!accumulator[year]) {
                    accumulator[year] = {
                        name: year,
                        color: Utils.generateChartColour(parseInt(year)),
                        data: [],
                    }
                }
                accumulator[year].data.push(currentValue.count)
                return accumulator
            },
            {}
        )

        this.chartOptions = {
            ...this.chartOptions,
            series: Object.values(manipulatedChartData),
        }

        this.chart.updateSeries(Object.values(manipulatedChartData))
    }
}
